// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mCmz","tabsBox":"styles_tabsBox__25rQB","createButton":"styles_createButton__3c6fl"};